/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

(function StickySidebar() {
    /**
     * handles the visibility of the stickySidebar
     *
     * @constructor
     */
    function stickySidebar(dom) {
        /**
         * // local object availability
         * @type {stickySidebar}
         * @private
         */
        var _this = this;

        /**
         * @type {int}
         * @private
         */
        this.scrollOffsetTop = dom.getAttribute('data-scroll-offset-top') || 600 ;

        /**
         * @type {string}
         * @private
         */
        this.localStorageItemName = 'shrink-sticky-sidebar';


        /**
         * @type {object}
         * @private
         */
        this.stickySidebarSwitcher = dom.querySelector("[data-js=sticky-sidebar__switcher]");

        /**
         * @method scrollVisibility
         * @returns {undefined}
         */
        this.scrollVisibility = function () {
            if (document.body.scrollTop > _this.scrollOffsetTop || document.documentElement.scrollTop > _this.scrollOffsetTop) {
                dom.classList.add("visible");
            } else {
                dom.classList.remove("visible");
            }
        };


        /**
         * @method initialLocalStorageObserver
         * @returns {undefined}
         */
        this.initialLocalStorageObserver = function (){
            if(localStorage.getItem(_this.localStorageItemName) == 'true'){
                dom.dataset.shrinkStickySidebar = true;
            } else {
                dom.dataset.shrinkStickySidebar = false;
            }
        }


        /**
         * @method shrinkAndExpendStickySidebar
         * @returns {undefined}
         */
        this.shrinkAndExpendStickySidebar = function (){
            if(localStorage.getItem(_this.localStorageItemName) == 'true'){
                dom.dataset.shrinkStickySidebar = false;
                localStorage.setItem(_this.localStorageItemName, false);
            } else {
                dom.dataset.shrinkStickySidebar = true;
                localStorage.setItem(_this.localStorageItemName, true);
            }
        }


        /**
         * @method bindEvents
         * @returns {undefined}
         */
        this.bindEvents = function () {
            document.onscroll = function () {
                _this.scrollVisibility();
            };

            this.stickySidebarSwitcher.onclick = () => {
                _this.shrinkAndExpendStickySidebar();
            };
        };

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.bindEvents();
            this.initialLocalStorageObserver();
        };

        /**
         * initialize call
         */
        this.init();
    }

    // define the global scope
    if (!window.Jumpers) {
        window.Jumpers = {};
    }

    window.Jumpers.stickySidebar = stickySidebar;
})();

$(function () {
    var stickySidebar = document.querySelector("[data-js=sticky-sidebar]");
    if (stickySidebar) {
        new window.Jumpers.stickySidebar(stickySidebar);
    }
});
